import React from 'react';
import { ChevronRight, Plus } from 'lucide-react';
import { ServiceItem } from '../types';
import { formatCurrency } from '../utils/price';

interface Props {
  service: ServiceItem;
  onClick: () => void;
}

export const ServiceCard: React.FC<Props> = ({ service, onClick }) => {
  const isOther = service.minPrice === 0 && service.maxPrice === 0;

  return (
    <div
      onClick={onClick}
      className={`group relative p-5 rounded-3xl flex justify-between items-center cursor-pointer transition-all duration-200
                 shadow-card hover:shadow-lg active:scale-[0.98] border 
                 ${isOther 
                   ? 'bg-blue-50/60 border-blue-200 hover:bg-blue-100/50' 
                   : 'bg-white border-transparent hover:border-blue-100'
                 }`}
    >
      <div className="flex-1 pr-4">
        <h3 className={`font-bold mb-1.5 text-lg leading-tight transition-colors ${isOther ? 'text-primary' : 'text-gray-900 group-hover:text-primary'}`}>
          {service.name}
        </h3>
        <div className={`inline-flex items-center px-2.5 py-1 rounded-lg transition-colors ${isOther ? 'bg-white/80 text-primary border border-blue-100' : 'bg-gray-50 group-hover:bg-blue-50'}`}>
            <p className={`text-sm font-bold ${isOther ? 'text-primary' : 'text-gray-600 group-hover:text-primary'}`}>
            {isOther ? 'Договорная цена' : 
                `${formatCurrency(service.minPrice)}`
            }
            </p>
            {service.maxPrice > 0 && (
                <span className="text-xs text-gray-400 ml-1 font-medium">– {formatCurrency(service.maxPrice)}</span>
            )}
        </div>
      </div>
      
      <div className={`w-10 h-10 rounded-full flex items-center justify-center transition-all shadow-sm ${isOther ? 'bg-primary text-white shadow-blue-300/50' : 'bg-gray-50 text-gray-400 group-hover:bg-primary group-hover:text-white'}`}>
        {isOther ? <Plus size={20} /> : <ChevronRight size={20} />}
      </div>
    </div>
  );
};